/**
 * Get nested value inside object using path with ability of updating
 *
 * @param {Object} object - Original object
 * @param {string} path - Path (ex: 'item.user.name')
 * @param {string} [separator=''] - Path separator (ex: '.' | '|')
 * @param {string} newValue - New value to update nested key
 * @returns {*} - Nested value
 */
export default function accessDeep(object, path, separator = '.', newValue) {
  const keys = path.split(separator);
  const lastKey = keys[keys.length - 1];

  let current = object;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    current = current[key];
  }

  if (newValue !== undefined) {
    current[lastKey] = newValue;
  }
  return current[lastKey];
}
